export const RETRIEVE_ALL_SERVICE_TYPES_REQUEST = "RETRIEVE_ALL_SERVICE_TYPES_REQUEST";
export const RETRIEVE_ALL_SERVICE_TYPES_SUCCESS = "RETRIEVE_ALL_SERVICE_TYPES_SUCCESS";
export const RETRIEVE_ALL_SERVICE_TYPES_FAILURE = "RETRIEVE_ALL_SERVICE_TYPES_FAILURE";
